<template>
	<div class="se_all">
		<div class="news_pc" v-if="!isPhone">
			<div class="page_tit" data-aos="fade-up">
				<p class="nc_p1">2020版剑南春全新防伪体系</p>
				<p class="nc_p2">2020版剑南春采用了三位一体的防伪技术，从外箱、外盒、瓶体三个环节运用防伪技术保障产品质量安全。</p>
			</div>
			<div class="fwbox1">
				<p class="nc_p3" data-aos="fade-up">三位一体防伪识别</p>
				<p class="nc_p4" data-aos="fade-up">外箱</p>
				<div class="tb_box flex2" data-aos="fade-up">
					<div class="tb_item flex2" @click="bbact=0" :class="bbact==0?'tab_act':''">
						<span>版本一</span>
						<img v-if="bbact!=0" src="@/images/fangwei/kg1.png">
						<img v-if="bbact==0" src="@/images/fangwei/kg2.png">
					</div>
					<div class="tb_item flex2" @click="bbact=1" :class="bbact==1?'tab_act':''">
						<span>版本二</span>
						<img v-if="bbact!=1" src="@/images/fangwei/kg1.png">
						<img v-if="bbact==1" src="@/images/fangwei/kg2.png">
					</div>
					<div class="tb_item flex2" @click="bbact=2" :class="bbact==2?'tab_act':''">
						<span>版本三</span>
						<img v-if="bbact!=2" src="@/images/fangwei/kg1.png">
						<img v-if="bbact==2" src="@/images/fangwei/kg2.png">
					</div>
				</div>
			</div>
			<!-- 版本1 -->
			<div v-if="bbact==0 || bbact==2">
				<div class="fwbox1">
					<div class="nc_d1" data-aos="fade-up">
						<div class="swiper_wrap">
							<swiper class="swiper_box1" :options="swiperOption" ref="mySwiper" @slideChange="onSlideChange">
								<swiper-slide v-if="bbact != 2" class="slid_item flex1">
									<div class="sl_left">
										<img src="@/images/fangwei/fwx1.png" />
									</div>
									<div class="sl_right">
										<p class="slrt_p1">新型胶带撕开效果</p>
										<div class="slrt_p2">
											2024年11月起，全面启用新的防伪胶带，新胶带揭开后，在酒箱上留下“已开封”字样。
										</div>
									</div>
								</swiper-slide>
								<swiper-slide v-if="bbact != 2" class="slid_item flex1">
									<div class="sl_left">
										<img src="@/images/fangwei/fwx2.png" />
									</div>
									<div class="sl_right">
										<p class="slrt_p1">外箱顶部</p>
										<div class="slrt_p2">
											剑南春外箱顶部印刷有客户代码、生产日期以及批次和版本信息。注意观察logo颜色是否饱满，图案边缘是否清晰，细节处理是否得当。
										</div>
									</div>
								</swiper-slide>
								<swiper-slide v-if="bbact == 2" class="slid_item flex1">
									<div class="sl_left">
										<img src="@/images/fangwei/bb01.png" />
									</div>
									<div class="sl_right">
										<p class="slrt_p1">外箱顶部</p>
										<div class="slrt_p2">
											剑南春外箱顶部印刷有客户代码、生产日期以及批次和版本信息。注意观察logo颜色是否饱满，图案边缘是否清晰，细节处理是否得当。
										</div>
									</div>
								</swiper-slide>
								<swiper-slide v-if="bbact == 2" class="slid_item flex1">
									<div class="sl_left">
										<img src="@/images/fangwei/bb02.png" />
									</div>
									<div class="sl_right">
										<p class="slrt_p1">外箱侧面</p>
										<div class="slrt_p2">
											外箱侧面贴有物流标，物流标所示生产时间与箱内每瓶酒为对应关系，物流标下部24位物流码也可通过我公司内部数据库进行查询。
										</div>
									</div>
								</swiper-slide>
								<swiper-slide v-if="bbact == 2" class="slid_item flex1">
									<div class="sl_left">
										<img src="@/images/fangwei/bb03.png" />
									</div>
									<div class="sl_right">
										<p class="slrt_p1">外箱防伪标</p>
										<div class="slrt_p2">
											二维码扫描外箱防伪标可查询产品真伪信息，将扫描结果与外箱防伪标进行核对，逐一观察彩色亮片的分布位置、数量是否相符，若相符则说明是真品，并且，彩色亮片可用针或者刀尖挑出，非印刷墨迹，请注意区别。
										</div>
									</div>
								</swiper-slide>
							</swiper>
							<div class="change_box flex1" :style="{ width: bbact == 2 ? '350px' : '260px' }">
								<img @click="slidChange(1)" src="@/images/fangwei/left1.png" />
								<div class="change_tab flex3">
									<span v-if="bbact != 2" @click="slidChange2(0)" :class="actIndex == 0 ? 'pc_act1' : ''">新型胶带</span>
									<span v-if="bbact != 2" @click="slidChange2(1)" :class="actIndex == 1 ? 'pc_act1' : ''">外箱顶部</span>
									<span v-if="bbact == 2" @click="slidChange2(0)" :class="actIndex == 0 ? 'pc_act1' : ''">外箱顶部</span>
									<span v-if="bbact == 2" @click="slidChange2(1)" :class="actIndex == 1 ? 'pc_act1' : ''">外箱侧面</span>
									<span v-if="bbact == 2" @click="slidChange2(2)" :class="actIndex == 2 ? 'pc_act1' : ''">外箱防伪标</span>
								</div>
								<img @click="slidChange(2)" src="@/images/fangwei/right1.png" />
							</div>
						</div>
					</div>
				</div>
				<div class="fwbox2">
					<p class="nc_p3" data-aos="fade-up">三位一体防伪识别</p>
					<p class="nc_p4" data-aos="fade-up">外盒</p>
					<div class="carton_wrap" data-aos="fade-up">
						<ul class="flex1 carton_box" :class="{ carton_box_two: bbact == 2 }">
							<li class="carton_item">
								<div class="tm_con">
									<img :src="bbact == 2 ? require('@/images/fangwei/bb1.png') : require('@/images/fangwei/jiu1.png')" />
									<p>2020版剑南春正面图</p>
								</div>
							</li>
							<li class="carton_item">
								<div class="tm_con">
									<img :src="bbact == 2 ? require('@/images/fangwei/bb2.png') : require('@/images/fangwei/jiu2.png')" />
									<p>2020版剑南春侧面图</p>
								</div>
							</li>
							<li v-if="bbact != 2" class="carton_item">
								<div class="tm_con">
									<img src="@/images/fangwei/jiu3.png" />
									<p>2020版剑南春侧面图</p>
								</div>
							</li>
						</ul>
						<div v-if="bbact != 2" class="secbox3">
							<ul class="seclist2">
								<li class="st_box1 flex1" data-aos="fade-up">
									<div class="st_left">
										<img src="@/images/fangwei/fwx4.png" />
									</div>
									<div class="st_right">
										<div class="lt_box">
											<p class="lt_p1">剑南春外盒物流码</p>
											<p class="lt_p2">
												剑南春酒盒侧面破坏性拉环下方红色底盒上有一组激光烧刻的24位物流号码，在物流码下方红色底盒上烧刻了生产日期，一箱内六盒酒均为同一日期，并与外箱顶部生产日期一致。
											</p>
										</div>
									</div>
								</li>
								<li class="st_box1 flex1" data-aos="fade-up">
									<div class="st_right">
										<div class="lt_box">
											<p class="lt_p1">外盒防伪标</p>
											<p class="lt_p2">
												微信扫描防伪标二维码，可查询到产品的批次、生产日期以及经销商信息。将扫描结果与实物进行对比，核对实物标识的文字、图案是否与之相符：防伪标识上有彩色亮片，手摸有凸感，右侧红色温变线遇热褪色，实物标识与存档图亮片的颜色、位置相符，并且可挑出，若不符则防伪标识为假冒。请注意甄别。
											</p>
										</div>
									</div>
									<div class="st_left">
										<img src="@/images/fangwei/fwx5.png" />
									</div>
								</li>
							</ul>
						</div>
						<template v-else>
							<div class="secbox3 secbox3_version_three" style="margin-top: -4px;">
								<ul class="seclist2">
									<li class="st_box1 flex1" data-aos="fade-up">
										<div class="st_left">
											<img src="@/images/fangwei/bb3.png" />
										</div>
										<div class="st_right">
											<div class="lt_box">
												<p class="lt_p1">剑南春外盒物流码</p>
												<p class="lt_p2">
													剑南春酒盒侧面破坏性拉环下方红色底盒上有一组激光烧刻的24位物流号码，在物流码下方红色底盒上烧刻了生产日期，一箱内六盒酒均为同一日期，并与外箱顶部生产日期一致。
												</p>
											</div>
										</div>
									</li>
								</ul>
							</div>
							<div class="secbox3 secbox3_version_three">
								<ul class="seclist2">
									<li class="st_box1 flex1" data-aos="fade-up">
										<div class="st_right">
											<div class="lt_box">
												<p class="lt_p1">外盒防伪标</p>
												<p class="lt_p2">综合全息防伪技术</p>
												<p class="lt_p2">· 裸眼3D效果 · 猫眼效果 · 景深文字清晰：背景虚化</p>
												<p class="lt_p2">· 铂金浮雕：Logo为立体浮雕效果</p>
												<p class="lt_p2 lt_p2_hanging">· 菲涅尔透镜+微缩文字：用20倍以上放大镜观察可见“唐时宫廷酒 今日剑南春”文字</p>
												<p class="lt_p2">· 动态追焦：“JNC”文字随点光源动态移动</p>
												<p class="lt_p2">· 3D翻转动态效果 · 专用防伪版纹 · 锯齿二维码</p>
												<p class="lt_p2">· 磁性3D油墨：晃动标签，剑南春字体会有金色光柱闪动</p>
												<p class="lt_p2 lt_p2_hanging">· 无色荧光（变黄）：常光下无色，荧光显现黄色“JNC”字样</p>
												<p class="lt_p2 lt_p2_hanging">· 局部随机纹理（彩色亮片+绒毛纤维）：专用设备制作出随机分布的防伪纤维层，具有唯一性特征</p>
												<p class="lt_p2 lt_p2_hanging">· 全息烫印随机图案：全新AI自动识别技术，手机扫码，根据提示操作，自动鉴别真伪</p>
											</div>
										</div>
										<div class="st_left">
											<img src="@/images/fangwei/bb4.png" />
										</div>
									</li>
								</ul>
							</div>
						</template>
					</div>
				</div>
				<div class="fwbox3">
					<p class="nc_p3" data-aos="fade-up">三位一体防伪识别</p>
					<p class="nc_p4" data-aos="fade-up">酒瓶</p>
					<div class="secbox3">
						<ul class="seclist2">
							<li class="st_box1 flex1" data-aos="fade-up">
								<div class="st_left">
									<img :src="bbact == 2 ? require('@/images/fangwei/bb5.png') : require('@/images/fangwei/fwx6.png')" />
								</div>
								<div class="st_right">
									<div class="lt_box">
										<p class="lt_p1">瓶盖</p>
										<p class="lt_p2">
											采用二维码喷印瓶盖，扫描可获取产品促销活动信息。瓶盖上有激光烧刻24位物流码、生产日期及产品批号。
										</p>
									</div>
								</div>
							</li>
							<li class="st_box1 flex1" data-aos="fade-up">
								<div class="st_right">
									<div class="lt_box">
										<p class="lt_p1">酒瓶纹理防伪标</p>
										<p v-if="bbact != 2" class="lt_p2">
											纹理防伪标采用热敏防伪技术，加热后会出现“加热失效”字样。还可通过拨打400-6800315，按语音提示操作，进行真伪查询。同时也可通过网络查询真伪，进入拍拍看<a
												href="https://www.315net.com"
												target="_blank">www.315net.com</a>，按页面提示输入序号，将查询到的信息与实物核对，若不符，则防伪标识为假冒。
										</p>
										<template v-else>
											<p class="lt_p2">· 不可逆温变油墨：加热到70°C后显现“变色失效”字样</p>
											<p class="lt_p2 lt_p2_hanging">· 磁性3D油墨：晃动标签，“剑南春”字体会有金色光柱闪动</p>
											<p class="lt_p2">· 专用防伪版纹：“JNC”立体浮雕</p>
											<p class="lt_p2 lt_p2_hanging">· 全息烫印随机图案：全息图案包含激光彩虹效果和随机可变数字、</p>
											<p class="lt_p2">· 无色荧光(黄)：荧光灯照射显现黄色“JNC”字样</p>
											<p class="lt_p2 lt_p2_hanging">· 局部随机纹理(彩色亮片+绒毛纤维)：专用设备制作出随机分布的防伪纤维层，具有唯一性特征</p>
										</template>
									</div>
								</div>
								<div class="st_left">
									<img :src="bbact == 2 ? require('@/images/fangwei/bb6.png') : require('@/images/fangwei/fwx7.png')" />
								</div>
							</li>
						</ul>
					</div>
				</div>
				<div v-if="bbact != 2" class="fwbox4">
					<p class="nc_p3" data-aos="fade-up">膜类防伪标识别</p>
					<p class="nc_p4" data-aos="fade-up">外盒</p>
					<ul class="flex1 wh_ul">
						<li class="wh_li">
							<div class="tm_con" data-aos="fade-up">
								<img src="@/images/fangwei/jiu4.png" />
								<p>正面图</p>
							</div>
						</li>
						<li class="wh_li">
							<div class="tm_con" data-aos="fade-up">
								<img src="@/images/fangwei/jiu5.png" />
								<p>侧面图</p>
							</div>
						</li>
					</ul>
					<div class="secbox3">
						<ul class="seclist2">
							<li class="st_box1 flex1" data-aos="fade-up">
								<div class="st_left">
									<img src="@/images/fangwei/fwx8.png" />
								</div>
								<div class="st_right">
									<div class="lt_box">
										<p class="lt_p1">外盒防伪标</p>
										<p class="lt_p2">
											1.不同角度下，“剑南春”的颜色不一样
										</p>
										<p class="lt_p2">
											2.强光照射中部区域，变换角度，可见“剑南春”三个字
										</p>
										<p class="lt_p2">
											3.不同角度下，可见金色到彩亮的变化
										</p>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
				<div v-if="bbact != 2" class="fwbox5">
					<p class="nc_p3" data-aos="fade-up">膜类防伪标识别</p>
					<p class="nc_p4" data-aos="fade-up">酒瓶</p>
					<div class="secbox3">
						<ul class="seclist2">
							<li class="st_box1 flex1" data-aos="fade-up">
								<div class="st_left">
									<img src="@/images/fangwei/fwx9.png" />
								</div>
								<div class="st_right">
									<div class="lt_box">
										<p class="lt_p1">瓶盖防伪标</p>
										<p class="lt_p2">
											1.强光照射下，变换角度，可见“JNC”三个字母
										</p>
										<p class="lt_p2">
											2.不同角度下，“剑南春”的颜色不一样
										</p>
										<p class="lt_p2">
											3.用手触摸标签圆形纤维有凹凸感挑，可挑出圆形纤维膜类防伪标查询电话为：4008161365
										</p>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<!-- 版本2 -->
			<div v-if="bbact==1">
				<div class="fwbox1">
					<div class="nc_d1" data-aos="fade-up">
						<div class="swiper_wrap">
							<swiper class="swiper_box1" :options="swiperOption" ref="mySwiper" @slideChange="onSlideChange">
								<swiper-slide class="slid_item flex1">
									<div class="sl_left">
										<img src="@/images/fangwei/bb_img1.png" />
									</div>
									<div class="sl_right">
										<p class="slrt_p1">外箱顶部</p>
										<div class="slrt_p2">
											剑南春外箱顶部印刷有客户代码、生产日期以及批次和版本信息。注意观察logo颜色是否饱满，图案边缘是否清晰，细节处理是否得当。
										</div>
									</div>
								</swiper-slide>
								<swiper-slide class="slid_item flex1">
									<div class="sl_left">
										<img src="@/images/fangwei/bb_img2.png" />
									</div>
									<div class="sl_right">
										<p class="slrt_p1">外箱侧面</p>
										<div class="slrt_p2">
											外箱侧面贴有物流标，物流标所示生产时间与箱内每瓶酒为对应关系，物流标下部24位物流码也可通过我公司内部数据库进行查询。
										</div>
									</div>
								</swiper-slide>
								<swiper-slide class="slid_item flex1">
									<div class="sl_left">
										<img src="@/images/fangwei/bb_img3.png" />
									</div>
									<div class="sl_right">
										<p class="slrt_p1">外箱防伪标</p>
										<div class="slrt_p2">
											二维码扫描外箱防伪标可查询产品真伪信息，将扫描结果与外箱防伪标进行核对，逐一观察彩色亮片的分布位置、数量是否相符，若相符则说明是真品，并且，彩色亮片可用针或者刀尖挑出，非印刷墨迹，请注意区别。
										</div>
									</div>
								</swiper-slide>
							</swiper>
							<div class="change_box flex1">
								<img @click="slidChange(1)" src="@/images/fangwei/left1.png" />
								<div class="change_tab flex3">
									<span @click="slidChange2(0)" :class="actIndex == 0 ? 'pc_act1' : ''">外箱顶部</span>
									<span @click="slidChange2(1)" :class="actIndex == 1 ? 'pc_act1' : ''">外箱侧面</span>
									<span @click="slidChange2(2)" :class="actIndex == 2 ? 'pc_act1' : ''">外箱防伪标</span>
								</div>
								<img @click="slidChange(2)" src="@/images/fangwei/right1.png" />
							</div>
						</div>
					</div>
				</div>
				<div class="fwbox2">
					<p class="nc_p3" data-aos="fade-up">三位一体防伪识别</p>
					<p class="nc_p4" data-aos="fade-up">外盒</p>
					<div class="carton_wrap" data-aos="fade-up">
						<ul class="flex1 carton_box">
							<li class="carton_item">
								<div class="tm_con">
									<img src="@/images/fangwei/jiu1.png" />
									<p>2020版剑南春正面图</p>
								</div>
							</li>
							<li class="carton_item">
								<div class="tm_con">
									<img src="@/images/fangwei/jiu2.png" />
									<p>2020版剑南春侧面图</p>
								</div>
							</li>
							<li class="carton_item">
								<div class="tm_con">
									<img src="@/images/fangwei/jiu3.png" />
									<p>2020版剑南春侧面图</p>
								</div>
							</li>
						</ul>
						<div class="secbox3">
							<ul class="seclist2">
								<li class="st_box1 flex1" data-aos="fade-up">
									<div class="st_left">
										<img src="@/images/fangwei/fwx4.png" />
									</div>
									<div class="st_right">
										<div class="lt_box">
											<p class="lt_p1">剑南春外盒物流码</p>
											<p class="lt_p2">
												剑南春酒盒侧面破坏性拉环下方红色底盒上有一组激光烧刻的24位物流号码，在物流码下方红色底盒上烧刻了生产日期，一箱内六盒酒均为同一日期，并与外箱顶部生产日期一致。
											</p>
										</div>
									</div>
								</li>
								<li class="st_box1 flex1" data-aos="fade-up">
									<div class="st_right">
										<div class="lt_box">
											<p class="lt_p1">外盒防伪标</p>
											<p class="lt_p2">
												微信扫描防伪标二维码，可查询到产品的批次、生产日期以及经销商信息。将扫描结果与实物进行对比，核对实物标识的文字、图案是否与之相符：防伪标识上有彩色亮片，手摸有凸感，右侧红色温变线遇热褪色，实物标识与存档图亮片的颜色、位置相符，并且可挑出，若不符则防伪标识为假冒。请注意甄别。
											</p>
										</div>
									</div>
									<div class="st_left">
										<img src="@/images/fangwei/fwx5.png" />
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div class="fwbox3">
					<p class="nc_p3" data-aos="fade-up">三位一体防伪识别</p>
					<p class="nc_p4" data-aos="fade-up">酒瓶</p>
					<div class="secbox3">
						<ul class="seclist2">
							<li class="st_box1 flex1" data-aos="fade-up">
								<div class="st_left">
									<img src="@/images/fangwei/fwx6.png" />
								</div>
								<div class="st_right">
									<div class="lt_box">
										<p class="lt_p1">瓶盖</p>
										<p class="lt_p2">
											采用二维码喷印瓶盖，扫描可获取产品促销活动信息。瓶盖上有激光烧刻24位物流码、生产日期及产品批号。
										</p>
									</div>
								</div>
							</li>
							<li class="st_box1 flex1" data-aos="fade-up">
								<div class="st_right">
									<div class="lt_box">
										<p class="lt_p1">酒瓶纹理防伪标</p>
										<p class="lt_p2">
											纹理防伪标采用热敏防伪技术，加热后会出现“加热失效”字样。还可通过拨打400-6800315，按语音提示操作，进行真伪查询。同时也可通过网络查询真伪，进入拍拍看<a
												href="https://www.315net.com"
												target="_blank">www.315net.com</a>，按页面提示输入序号，将查询到的信息与实物核对，若不符，则防伪标识为假冒。
										</p>
									</div>
								</div>
								<div class="st_left">
									<img src="@/images/fangwei/fwx7.png" />
								</div>
							</li>
						</ul>
					</div>
				</div>
				<div class="fwbox4">
					<p class="nc_p3" data-aos="fade-up">膜类防伪标识别</p>
					<p class="nc_p4" data-aos="fade-up">外盒</p>
					<ul class="flex1 wh_ul">
						<li class="wh_li">
							<div class="tm_con" data-aos="fade-up">
								<img src="@/images/fangwei/jiu4.png" />
								<p>正面图</p>
							</div>
						</li>
						<li class="wh_li">
							<div class="tm_con" data-aos="fade-up">
								<img src="@/images/fangwei/jiu5.png" />
								<p>侧面图</p>
							</div>
						</li>
					</ul>
					<div class="secbox3">
						<ul class="seclist2">
							<li class="st_box1 flex1" data-aos="fade-up">
								<div class="st_left">
									<img src="@/images/fangwei/fwx8.png" />
								</div>
								<div class="st_right">
									<div class="lt_box">
										<p class="lt_p1">外盒防伪标</p>
										<p class="lt_p2">
											1.不同角度下，“剑南春”的颜色不一样
										</p>
										<p class="lt_p2">
											2.强光照射中部区域，变换角度，可见“剑南春”三个字
										</p>
										<p class="lt_p2">
											3.不同角度下，可见金色到彩亮的变化
										</p>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
				<div class="fwbox5">
					<p class="nc_p3" data-aos="fade-up">膜类防伪标识别</p>
					<p class="nc_p4" data-aos="fade-up">酒瓶</p>
					<div class="secbox3">
						<ul class="seclist2">
							<li class="st_box1 flex1" data-aos="fade-up">
								<div class="st_left">
									<img src="@/images/fangwei/fwx9.png" />
								</div>
								<div class="st_right">
									<div class="lt_box">
										<p class="lt_p1">瓶盖防伪标</p>
										<p class="lt_p2">
											1.强光照射下，变换角度，可见“JNC”三个字母
										</p>
										<p class="lt_p2">
											2.不同角度下，“剑南春”的颜色不一样
										</p>
										<p class="lt_p2">
											3.用手触摸标签圆形纤维有凹凸感挑，可挑出圆形纤维膜类防伪标查询电话为：4008161365
										</p>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="rd_box">
				<record></record>
			</div>
		</div>
		<div class="news_phone" v-if="isPhone">
			<Header2 :searchShow="false" pageTitle="防伪查询"></Header2>
			<div class="tab_nav">
				<div class="nav_box">
					<span @click="zrTabChange(0)" :class="tabAct == 0 ? 'ph_act1' : ''">全新三位一体防伪</span>
					<span @click="zrTabChange(1)" :class="tabAct == 1 ? 'ph_act1' : ''">三重八关防伪体系</span>
				</div>
			</div>
			<div class="tab_con1" v-if="tabAct == 0">
				<div class="phone_tit1">
					<p class="nc_p1" data-aos="fade-up">剑南春防伪体系</p>
					<p class="nc_p2" data-aos="fade-up">
						2020版剑南春采用了三位一体的防伪技术，从外箱、外盒、瓶体三个环节运用防伪技术保障产品质量安全。
					</p>
				</div>
				<div class="phbox1">
					<p class="nc_p3" data-aos="fade-up">三位一体防伪识别</p>
					<p class="nc_p4" data-aos="fade-up">外箱</p>
					<div class="tb_box flex2" data-aos="fade-up">
						<div class="tb_item flex2" @click="bbact=0" :class="bbact==0?'tab_act':''">
							<span>版本一</span>
							<img v-if="bbact!=0" src="@/images/fangwei/kg1.png">
							<img v-if="bbact==0" src="@/images/fangwei/kg2.png">
						</div>
						<div class="tb_item flex2" @click="bbact=1" :class="bbact==1?'tab_act':''">
							<span>版本二</span>
							<img v-if="bbact!=1" src="@/images/fangwei/kg1.png">
							<img v-if="bbact==1" src="@/images/fangwei/kg2.png">
						</div>
						<div class="tb_item flex2" @click="bbact=2" :class="bbact==2?'tab_act':''">
							<span>版本三</span>
							<img v-if="bbact!=2" src="@/images/fangwei/kg1.png">
							<img v-if="bbact==2" src="@/images/fangwei/kg2.png">
						</div>
					</div>
				</div>
				<div v-if="bbact == 0 || bbact == 2">
					<div class="phbox1">
						<div class="nc_d11">
							<div class="swiper_wrap" data-aos="fade-up">
								<swiper class="swiper_box1" :options="swiperOption2" ref="mySwiper2">
									<swiper-slide v-if="bbact != 2" class="slid_item">
										<div class="sl_left">
											<img src="@/images/fangwei/fwx1.png" />
										</div>
										<div class="sl_right">
											<p class="slrt_p1">新型胶带撕开效果</p>
											<div class="slrt_p2">
												2024年11月起，全面启用新的防伪胶带，新胶带揭开后，在酒箱上留下“已开封”字样
											</div>
										</div>
									</swiper-slide>
									<swiper-slide v-if="bbact != 2" class="slid_item">
										<div class="sl_left">
											<img src="@/images/fangwei/fwx2.png" />
										</div>
										<div class="sl_right">
											<p class="slrt_p1">外箱顶部</p>
											<div class="slrt_p2">
												剑南春外箱顶部印刷有客户代码、生产日期以及批次和版本信息。注意观察logo颜色是否饱满，图案边缘是否清晰，细节处理是否得当。
											</div>
										</div>
									</swiper-slide>
									<swiper-slide v-if="bbact == 2" class="slid_item">
										<div class="sl_left">
											<img src="@/images/fangwei/bb01.png" />
										</div>
										<div class="sl_right">
											<p class="slrt_p1">外箱顶部</p>
											<div class="slrt_p2">
												剑南春外箱顶部印刷有客户代码、生产日期以及批次和版本信息。注意观察logo颜色是否饱满，图案边缘是否清晰，细节处理是否得当。
											</div>
										</div>
									</swiper-slide>
									<swiper-slide v-if="bbact == 2" class="slid_item">
										<div class="sl_left">
											<img src="@/images/fangwei/bb02.png" />
										</div>
										<div class="sl_right">
											<p class="slrt_p1">外箱侧面</p>
											<div class="slrt_p2">
												外箱侧面贴有物流标，物流标所示生产时间与箱内每瓶酒为对应关系，物流标下部24位物流码也可通过我公司内部数据库进行查询。
											</div>
										</div>
									</swiper-slide>
									<swiper-slide v-if="bbact == 2" class="slid_item">
										<div class="sl_left">
											<img src="@/images/fangwei/bb03.png" />
										</div>
										<div class="sl_right">
											<p class="slrt_p1">外箱防伪标</p>
											<div class="slrt_p2">
												二维码扫描外箱防伪标可查询产品真伪信息，将扫描结果与外箱防伪标进行核对，逐一观察彩色亮片的分布位置、数量是否相符，若相符则说明是真品，并且，彩色亮片可用针或者刀尖挑出，非印刷墨迹，请注意区别。
											</div>
										</div>
									</swiper-slide>
									<div class="swiper-pagination" slot="pagination"></div>
								</swiper>
							</div>
						</div>
					</div>
					<div class="phbox2">
						<p class="nc_p3" data-aos="fade-up">
							三位一体防伪识别
						</p>
						<p class="nc_p4" data-aos="fade-up">
							外盒
						</p>
						<div class="carton_wrap">
						<ul class="carton_box" :class="{ carton_box_two: bbact == 2 }">
								<li class="carton_item" data-aos="fade-up">
									<div class="tm_con">
										<img :src="bbact == 2 ? require('@/images/fangwei/bb1.png') : require('@/images/fangwei/jiu1.png')" />
										<p>2020版剑南春正面图</p>
									</div>
								</li>
								<li class="carton_item" data-aos="fade-up">
									<div class="tm_con">
										<img :src="bbact == 2 ? require('@/images/fangwei/bb2.png') : require('@/images/fangwei/jiu2.png')" />
										<p>2020版剑南春侧面图</p>
									</div>
								</li>
								<li v-if="bbact != 2" class="carton_item" data-aos="fade-up">
									<div class="tm_con">
										<img src="@/images/fangwei/jiu3.png" />
										<p>2020版剑南春侧面图</p>
									</div>
								</li>
							</ul>
							<ul class="carton_box2" :class="{ carton_box2_version_three: bbact == 2 }">
								<li class="carton_item" data-aos="fade-up">
									<div class="tm_con">
										<img :src="bbact == 2 ? require('@/images/fangwei/bb3.png') : require('@/images/fangwei/wh3.png')" />
									</div>
								</li>
								<div class="whfw2" data-aos="fade-up">
									<p class="slrt_p12">剑南春外盒物流码</p>
									<p class="slrt_p22">
										剑南春酒盒侧面破坏性拉环下方红色底盒上有一组激光烧刻的24位物流号码，在物流码下方红色底盒上烧刻了生产日期，一箱内六盒酒均为同一日期，并与外箱顶部生产日期一致。
									</p>
								</div>
								<li class="carton_item" data-aos="fade-up">
									<div class="tm_con">
										<img :src="bbact == 2 ? require('@/images/fangwei/bb4.png') : require('@/images/fangwei/wh44.png')" />
									</div>
								</li>
								<div class="whfw2" data-aos="fade-up">
									<p class="slrt_p12">外盒防伪标</p>
									<p v-if="bbact != 2" class="slrt_p22">
										微信扫描防伪标二维码，可查询到产品的批次、生产日期以及经销商信息。将扫描结果与实物进行对比，核对实物标识的文字、图案是否与之相符：防伪标识上有彩色亮片，手摸有凸感，右侧红色温变线遇热褪色，实物标识与存档图亮片的颜色、位置相符，并且可挑出，若不符则防伪标识为假冒。请注意甄别。
									</p>
									<template v-else>
										<p class="slrt_p22">· 裸眼3D效果 · 猫眼效果 · 景深文字清晰：背景虚化</p>
										<p class="slrt_p22">· 铂金浮雕：Logo为立体浮雕效果</p>
										<p class="slrt_p22 lt_p2_hanging">· 菲涅尔透镜+微缩文字：用20倍以上放大镜观察可见“唐时宫廷酒 今日剑南春”文字</p>
										<p class="slrt_p22">· 动态追焦：“JNC”文字随点光源动态移动</p>
										<p class="slrt_p22">· 3D翻转动态效果 · 专用防伪版纹 · 锯齿二维码</p>
										<p class="slrt_p22">· 磁性3D油墨：晃动标签，剑南春字体会有金色光柱闪动</p>
										<p class="slrt_p22 lt_p2_hanging">· 无色荧光（变黄）：常光下无色，荧光显现黄色“JNC”字样</p>
										<p class="slrt_p22 lt_p2_hanging">· 局部随机纹理（彩色亮片+绒毛纤维）：专用设备制作出随机分布的防伪纤维层，具有唯一性特征</p>
										<p class="slrt_p22 lt_p2_hanging">· 全息烫印随机图案：全新AI自动识别技术，手机扫码，根据提示操作，自动鉴别真伪</p>
									</template>
								</div>
							</ul>
						</div>
					</div>
					<div class="phbox2">
						<p class="nc_p3" data-aos="fade-up">
							三位一体防伪识别
						</p>
						<p class="nc_p4" data-aos="fade-up">
							酒瓶
						</p>
						<div class="carton_wrap">
							<ul class="carton_box2">
								<li class="carton_item" data-aos="fade-up">
									<div class="tm_con">
										<img :src="bbact == 2 ? require('@/images/fangwei/bb5.png') : require('@/images/fangwei/fwx6.png')" />
									</div>
								</li>
								<div class="whfw2" data-aos="fade-up">
									<p class="slrt_p12">瓶盖</p>
									<p class="slrt_p22">
										采用二维码喷印瓶盖，扫描可获取产品促销活动信息。瓶盖上有激光烧刻24位物流码、生产日期及产品批号。
									</p>
								</div>
								<li class="carton_item" data-aos="fade-up">
									<div class="tm_con">
										<img :src="bbact == 2 ? require('@/images/fangwei/bb6.png') : require('@/images/fangwei/fwx7.png')" />
									</div>
								</li>
								<div class="whfw2" data-aos="fade-up">
									<p class="slrt_p12">酒瓶纹理防伪标</p>
									<p v-if="bbact != 2" class="slrt_p22">
										纹理防伪标采用热敏防伪技术，加热后会出现“加热失效”字样。还可通过拨打400-6800315，按语音提示操作，进行真伪查询。同时也可通过网络查询真伪，进入拍拍看<a
											href="https://www.315net.com"
											target="_blank">www.315net.com</a>，按页面提示输入序号，将查询到的信息与实物核对，若不符，则防伪标识为假冒。
										</p>
									<template v-else>
										<p class="slrt_p22">· 不可逆温变油墨：加热到70°C后显现“变色失效”字样</p>
										<p class="slrt_p22 lt_p2_hanging">· 磁性3D油墨：晃动标签，“剑南春”字体会有金色光柱闪动</p>
										<p class="slrt_p22">· 专用防伪版纹：“JNC”立体浮雕</p>
										<p class="slrt_p22 lt_p2_hanging">· 全息烫印随机图案：全息图案包含激光彩虹效果和随机可变数字、</p>
										<p class="slrt_p22">· 无色荧光(黄)：荧光灯照射显现黄色“JNC”字样</p>
										<p class="slrt_p22 lt_p2_hanging">· 局部随机纹理(彩色亮片+绒毛纤维)：专用设备制作出随机分布的防伪纤维层，具有唯一性特征</p>
									</template>
								</div>
							</ul>
						</div>
					</div>
					<div v-if="bbact != 2" class="phbox2">
						<p class="nc_p3" data-aos="fade-up">
							膜类防伪标识别
						</p>
						<p class="nc_p4" data-aos="fade-up">
							外盒
						</p>
						<div class="carton_wrap">
							<ul class="carton_box">
								<li class="carton_item" data-aos="fade-up">
									<div class="tm_con">
										<img src="@/images/fangwei/jiu4.png" />
										<p>正面图</p>
									</div>
								</li>
								<li class="carton_item" data-aos="fade-up">
									<div class="tm_con">
										<img src="@/images/fangwei/jiu5.png" />
										<p>侧面图</p>
									</div>
								</li>
							</ul>
							<ul class="carton_box2">
								<li class="carton_item" data-aos="fade-up">
									<div class="tm_con">
										<img src="@/images/fangwei/fwx8.png" />
									</div>
								</li>
								<div class="whfw2" data-aos="fade-up">
									<p class="slrt_p12">外盒防伪标</p>
									<p class="slrt_p22">
										1.不同角度下，"剑南春"的颜色不一样
										<br />
										2.强光照射中部区域，变换角度，可见"剑南春"三个字
										<br />
										3.不同角度下，可见金色到彩亮的变化
									</p>
								</div>
							</ul>
						</div>
					</div>
					<div v-if="bbact != 2" class="phbox2">
						<p class="nc_p3" data-aos="fade-up">
							膜类防伪标识别
						</p>
						<p class="nc_p4" data-aos="fade-up">
							酒瓶
						</p>
						<div class="carton_wrap">
							<ul class="carton_box2">
								<li class="carton_item" data-aos="fade-up">
									<div class="tm_con">
										<img src="@/images/fangwei/fwx8.png" />
									</div>
								</li>
								<div class="whfw2" data-aos="fade-up">
									<p class="slrt_p12">瓶盖防伪标</p>
									<p class="slrt_p22">
										1.强光照射下，变换角度，可见"JNC"三个字母
										<br />
										2.不同角度下，"剑南春"的颜色不一样
										<br />
										3.用手触摸标签圆形纤维有凹凸感挑，可挑出圆形纤维膜类防伪标查询电话为：4008161365
									</p>
								</div>
							</ul>
						</div>
					</div>
				</div>
				<div v-if="bbact ==1 ">
					<div class="phbox1">
						<div class="nc_d11" data-aos="fade-up">
							<div class="swiper_wrap">
								<swiper class="swiper_box1" :options="swiperOption2" ref="mySwiper2">
									<swiper-slide v-if="bbact != 2" class="slid_item">
										<div class="sl_left">
											<img src="@/images/fangwei/bb_img1.png" />
										</div>
										<div class="sl_right">
											<p class="slrt_p1">外箱顶部</p>
											<div class="slrt_p2">
												剑南春外箱顶部印刷有客户代码、生产日期以及批次和版本信息。注意观察logo颜色是否饱满，图案边缘是否清晰，细节处理是否得当。
											</div>
										</div>
									</swiper-slide>
									<swiper-slide class="slid_item">
										<div class="sl_left">
											<img src="@/images/fangwei/bb_img2.png" />
										</div>
										<div class="sl_right">
											<p class="slrt_p1">外箱侧面</p>
											<div class="slrt_p2">
												外箱侧面贴有物流标，物流标所示生产时间与箱内每瓶酒为对应关系，物流标下部24位物流码也可通过我公司内部数据库进行查询。
											</div>
										</div>
									</swiper-slide>
									<swiper-slide class="slid_item">
										<div class="sl_left">
											<img src="@/images/fangwei/bb_img3.png" />
										</div>
										<div class="sl_right">
											<p class="slrt_p1">外箱防伪标</p>
											<div class="slrt_p2">
												二维码扫描外箱防伪标可查询产品真伪信息，将扫描结果与外箱防伪标进行核对，逐一观察彩色亮片的分布位置、数量是否相符，若相符则说明是真品，并且，彩色亮片可用针或者刀尖挑出，非印刷墨迹，请注意区别。
											</div>
										</div>
									</swiper-slide>
									<div class="swiper-pagination" slot="pagination"></div>
								</swiper>
							</div>
						</div>
					</div>
                    <div class="phbox2">
						<p class="nc_p3" data-aos="fade-up">
							三位一体防伪识别
						</p>
						<p class="nc_p4" data-aos="fade-up">
							外盒
						</p>
						<div class="carton_wrap">
							<ul class="carton_box">
								<li class="carton_item" data-aos="fade-up">
									<div class="tm_con">
										<img src="@/images/fangwei/jiu1.png" />
										<p>2020版剑南春正面图</p>
									</div>
								</li>
								<li class="carton_item" data-aos="fade-up">
									<div class="tm_con">
										<img src="@/images/fangwei/jiu2.png" />
										<p>2020版剑南春侧面图</p>
									</div>
								</li>
								<li class="carton_item" data-aos="fade-up">
									<div class="tm_con">
										<img src="@/images/fangwei/jiu3.png" />
										<p>2020版剑南春侧面图</p>
									</div>
								</li>
							</ul>
							<ul class="carton_box2">
								<li class="carton_item" data-aos="fade-up">
									<div class="tm_con">
										<img src="@/images/fangwei/wh3.png" />
									</div>
								</li>
								<div class="whfw2" data-aos="fade-up">
									<p class="slrt_p12">剑南春外盒物流码</p>
									<p class="slrt_p22">
										剑南春酒盒侧面破坏性拉环下方红色底盒上有一组激光烧刻的24位物流号码，在物流码下方红色底盒上烧刻了生产日期，一箱内六盒酒均为同一日期，并与外箱顶部生产日期一致。
									</p>
								</div>
								<li class="carton_item" data-aos="fade-up">
									<div class="tm_con">
										<img src="@/images/fangwei/wh44.png" />
									</div>
								</li>
								<div class="whfw2" data-aos="fade-up">
									<p class="slrt_p12">剑南春外盒防伪标</p>
									<p class="slrt_p22">
										微信扫描防伪标二维码，可查询到产品的批次、生产日期以及经销商信息。将扫描结果与实物进行对比，核对实物标识的文字、图案是否与之相符：防伪标识上有彩色亮片，手摸有凸感，右侧红色温变线遇热褪色，实物标识与存档图亮片的颜色、位置相符，并且可挑出，若不符则防伪标识为假冒。请注意甄别。
									</p>
								</div>
							</ul>
						</div>
					</div>
					<div class="phbox2">
						<p class="nc_p3" data-aos="fade-up">
							三位一体防伪识别
						</p>
						<p class="nc_p4" data-aos="fade-up">
							酒瓶
						</p>
						<div class="carton_wrap">
							<ul class="carton_box2">
								<li class="carton_item" data-aos="fade-up">
									<div class="tm_con">
										<img src="@/images/fangwei/fwx6.png" />
									</div>
								</li>
								<div class="whfw2" data-aos="fade-up">
									<p class="slrt_p12">瓶盖</p>
									<p class="slrt_p22">
										采用二维码喷印瓶盖，扫描可获取产品促销活动信息。瓶盖上有激光烧刻24位物流码、生产日期及产品批号。
									</p>
								</div>
								<li class="carton_item" data-aos="fade-up">
									<div class="tm_con">
										<img src="@/images/fangwei/fwx7.png" />
									</div>
								</li>
								<div class="whfw2" data-aos="fade-up">
									<p class="slrt_p12">酒瓶纹理防伪标</p>
									<p class="slrt_p22">
										纹理防伪标采用热敏防伪技术，加热后会出现“加热失效”字样。还可通过拨打400-6800315，按语音提示操作，进行真伪查询。同时也可通过网络查询真伪，进入拍拍看<a
											href="https://www.315net.com"
											target="_blank">www.315net.com</a>，按页面提示输入序号，将查询到的信息与实物核对，若不符，则防伪标识为假冒。
									</p>
								</div>
							</ul>
						</div>
					</div>
					<div class="phbox2">
						<p class="nc_p3" data-aos="fade-up">
							膜类防伪标识别
						</p>
						<p class="nc_p4" data-aos="fade-up">
							外盒
						</p>
						<div class="carton_wrap">
							<ul class="carton_box">
								<li class="carton_item" data-aos="fade-up">
									<div class="tm_con">
										<img src="@/images/fangwei/jiu4.png" />
										<p>正面图</p>
									</div>
								</li>
								<li class="carton_item" data-aos="fade-up">
									<div class="tm_con">
										<img src="@/images/fangwei/jiu5.png" />
										<p>侧面图</p>
									</div>
								</li>
							</ul>
							<ul class="carton_box2">
								<li class="carton_item" data-aos="fade-up">
									<div class="tm_con">
										<img src="@/images/fangwei/fwx8.png" />
									</div>
								</li>
								<div class="whfw2" data-aos="fade-up">
									<p class="slrt_p12">外盒防伪标</p>
									<p class="slrt_p22">
										1.不同角度下，"剑南春"的颜色不一样
										<br />
										2.强光照射中部区域，变换角度，可见"剑南春"三个字
										<br />
										3.不同角度下，可见金色到彩亮的变化
									</p>
								</div>
							</ul>
						</div>
					</div>
					<div class="phbox2">
						<p class="nc_p3" data-aos="fade-up">
							膜类防伪标识别
						</p>
						<p class="nc_p4" data-aos="fade-up">
							酒瓶
						</p>
						<div class="carton_wrap">
							<ul class="carton_box2">
								<li class="carton_item" data-aos="fade-up">
									<div class="tm_con">
										<img src="@/images/fangwei/fwx8.png" />
									</div>
								</li>
								<div class="whfw2" data-aos="fade-up">
									<p class="slrt_p12">瓶盖防伪标</p>
									<p class="slrt_p22">
										1.强光照射下，变换角度，可见"JNC"三个字母
										<br />
										2.不同角度下，"剑南春"的颜色不一样
										<br />
										3.用手触摸标签圆形纤维有凹凸感挑，可挑出圆形纤维膜类防伪标查询电话为：4008161365
									</p>
								</div>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<div class="tab_con2" v-if="tabAct == 1">
				<p class="pb_p1" data-aos="fade-up">
					剑南春防伪体系
				</p>
				<p class="pb_p2" data-aos="fade-up">
					三重
				</p>
				<ul class="pb_p3">
					<li class="p3_item" data-aos="fade-up">
						<div class="p3_item_img">
							<img src="@/images/fangwei/omg1.png" />
							<span>1</span>
						</div>
						<p class="p3_item_p1">新型防伪标签</p>
						<p class="p3_item_p2">
							第一重：是指剑南春外盒新采用的是与最新版纸币防伪相似的世界领先的新型防伪标签。
						</p>
					</li>
					<li class="p3_item" data-aos="fade-up">
						<div class="p3_item_img">
							<img src="@/images/fangwei/omg2.png" />
							<span>2</span>
						</div>
						<p class="p3_item_p1">破坏性拉环防伪</p>
						<p class="p3_item_p2">
							第二重：为防止印有精密防伪标签的剑南春外包装盒被制假者利用，新的剑南春外包装盒采用了一次性开启拉环，当消费者通过防伪标签确认无误后，只要正常开启拉环，外包装盒即产生不可修复性破坏，彻底杜绝假冒者回收利用的可能！
						</p>
					</li>
					<li class="p3_item" data-aos="fade-up">
						<div class="p3_item_img">
							<img src="@/images/fangwei/omg3.png" />
							<span>3</span>
						</div>
						<p class="p3_item_p1">12位纹理防伪标签</p>
						<p class="p3_item_p2">
							第三重：纹理防伪标签的序号是唯一的（一瓶一号），纹理纤维的分布与查询结果一致，纤维能从纸张中挑出，以上三项都必须同时满足。不同时期的纹理防伪标签采用不同的形状和纤维丝，但基本原理一致，均需符合上述条件。
						</p>
					</li>
				</ul>
				<p class="pb_p2" data-aos="fade-up">
					八关
				</p>
				<ul class="pb_p4">
					<li class="pb_p4_item" data-aos="fade-up" v-for="(item, index) in glist2" :key="index">
						<div class="p4_img">
							<img :src="item.img" />
						</div>
						<div class="p4_text">
							<p class="p4_t1">{{ item.text1 }}</p>
							<p class="p4_t2">{{ item.text2 }}</p>
							<p class="p4_t3">{{ item.text3 }}</p>
						</div>
					</li>
				</ul>
				<p class="pb_p1" data-aos="fade-up">
					防伪打假
				</p>
				<ul class="pb_p5">
					<li class="pb_p5_item" data-aos="fade-up">
						<div class="p5_img1">
							<img src="@/images/fangwei/pmg1.png" />
						</div>
						<p class="p5_text">外箱有客户代码、生产日期、批次</p>
					</li>
					<li class="pb_p5_item pbtm2" data-aos="fade-up">
						<div class="p5_img1">
							<img src="@/images/fangwei/pmg2.png" />
						</div>
					</li>
					<li class="pb_p5_item" data-aos="fade-up">
						<div class="p5_img1">
							<img src="@/images/fangwei/pmg3.png" />
						</div>
					</li>
					<li class="pb_p5_item pbtm2" data-aos="fade-up">
						<div class="p5_img1">
							<img src="@/images/fangwei/pmg4.png" />
						</div>
						<p class="p5_text">
							剑南春酒盒“施瓦茨”防伪标识上方，有一组两行24位物流码（2007年5月到2012年11月期间使用的是20位物流码），同时在红色底盒上加注了生产日期和随机码。
						</p>
					</li>
				</ul>
				<p class="pb_p1" data-aos="fade-up">
					更多防伪
				</p>
				<ul class="pb_p6">
					<li class="p6_item" data-aos="fade-up">
						<p class="p6_tit1">微信查询</p>
						<div class="p6_text">
							<p>
								关注剑南春官方微信公众号，点击底部菜单：快捷服务—防伪查询。
							</p>
						</div>
					</li>
					<li class="p6_item" data-aos="fade-up">
						<p class="p6_tit1">短信查询</p>
						<div class="p6_text">
							<p>
								将防伪标签上的序号发至
								<a href="tel:13976088088">13976088088</a>
								接收彩信后可查询真伪。
							</p>
						</div>
					</li>
					<li class="p6_item" data-aos="fade-up">
						<p class="p6_tit1">电话查询</p>
						<div class="p6_text">
							<p>
								拨打电话
								<a href="tel:400-6800315">400-6800315</a>
								按语音提示进行操作。
							</p>
						</div>
					</li>
					<li class="p6_item" data-aos="fade-up">
						<p class="p6_tit1">网络查询</p>
						<div class="p6_text">
							<p>
								输入
								<a href="www.315net.com">www.315net.com</a>
								按页面提示输入序号即可查询真伪。
							</p>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			bbact: 0,
			isPhone: this.$isMobile,
			actIndex: 0,
			swiperOption: {
				pagination: {
					el: ".swiper-pagination",
					clickable: true,
				},
				// autoplay: true,
				// mousewheel: true,
				speed: 1000, //切换速度
			},
			swiperOption2: {
				pagination: {
					el: ".swiper-pagination",
					clickable: true,
				},
				autoplay: true,
				mousewheel: true,
				speed: 1000, //切换速度
			},
			glist2: [
				{
					text1: "第一关",
					text2: "防复印橘色",
					text3: "剑南春新型防伪标签采用了防复印橘色，在紫外灯照射下“防伪”和“标识”汉字处会出现防复印的橘色及随机荧光点。一些消费者喜欢随身携带微型紫外灯验钞机，可用它一照轻松识别，非常方便。",
					img: require("@/images/fangwei/g1.png"),
				},
				{
					text1: "第二关",
					text2: "烫金徽标",
					text3: "使用了高精度烫金徽标。",
					img: require("@/images/fangwei/g2.png"),
				},
				{
					text1: "第三关",
					text2: "热敏油墨",
					text3: "防伪标签右侧遇热后，粉红色会减弱变淡，散热后复原。",
					img: require("@/images/fangwei/g3.png"),
				},
				{
					text1: "第四关",
					text2: "中文微缩字",
					text3: "在剑南春新型防伪标上“防伪”与“标识”字样下，有高精度中文微缩文字“中国名酒剑南春”，在放大镜下清晰可见。",
					img: require("@/images/fangwei/g4.png"),
				},
				{
					text1: "第五关",
					text2: "英文微缩字",
					text3: "在剑南春新型防伪标上的两侧纽索纹下方，有一行蓝色高精度英文 “JIANNANCHUNDISTILLERY” 字样，在放大镜下可以清晰看到。",
					img: require("@/images/fangwei/g5.png"),
				},
				{
					text1: "第六关",
					text2: "安全模切",
					text3: "剑南春新型防伪标采用安全模切技术，一般消费者凭肉眼就能看到标志图案边缘的模切。",
					img: require("@/images/fangwei/g6.png"),
				},
				{
					text1: "第七关",
					text2: "镜像油墨",
					text3: "剑南春新型防伪标签采用了镜像油墨技术，在检测窗下，防伪标两侧的纽索纹颜色为红绿不同。",
					img: require("@/images/fangwei/g7.png"),
				},
				{
					text1: "第八关",
					text2: "激光油墨",
					text3: "剑南春新型防伪标签采用了激光油墨技术，在激光笔照射下，标签左右纽索纹和 R中，能测出亮点。",
					img: require("@/images/fangwei/g8.png"),
				},
			],
			//手机端js
			tabAct: 0,
		};
	},
	methods: {
		slidChange(a) {
			if (a == 1) {
				if (this.actIndex > 0) {
					this.$refs.mySwiper.$swiper.slideTo(this.actIndex - 1);
				}
			} else {
				if (this.actIndex < 2) {
					this.$refs.mySwiper.$swiper.slideTo(this.actIndex + 1);
				}
			}
		},
		slidChange2(a) {
			this.$refs.mySwiper.$swiper.slideTo(a);
		},
		onSlideChange() {
			const swiper = this.$refs.mySwiper.$swiper;
			this.actIndex = swiper.realIndex;
		},
		zrTabChange(index) {
			this.tabAct = index;
			window.scrollTo({
				top: 0,
			});
		},
	},
};
</script>

<style lang="scss">
/* 电脑端公共样式开始 */
.pc_act1 {
	font-size: 16px !important;
	color: #333 !important;
	// font-weight: bold;
}
.nc_p3 {
	color: #666;
	font-size: 28px;
	text-align: center;
	margin-bottom: 26px;
	animation-duration: 0.7s;
}
.nc_p4 {
	text-align: center;
	position: relative;
	color: #d43235;
	font-size: 36px;
	font-weight: 700;
	background-image: url("../../images/fangwei/fw1.png");
	background-repeat: no-repeat;
	background-position: bottom;
	margin-bottom: 46px;
	animation-duration: 0.7s;
}
.secbox3 {
	padding: 15px;
	background-color: #fff;
	.seclist2 {
		.st_box1 {
			.st_left {
				width: 50%;
				img {
					display: block;
					width: 100%;
				}
			}
			.st_right {
				width: 50%;
			}
		}
	}
}
.secbox3_version_three {
	margin-top: 10px;
	.seclist2 > .st_box1 + .st_box1 {
		margin-top: 30px;
	}
}
.lt_p1 {
	color: #d43236;
	font-size: 30px;
	position: relative;
	padding-bottom: 16px;
	margin-bottom: 24px;
	text-align: left;
	&::after {
		content: "";
		position: absolute;
		left: 0;
		bottom: 0;
		width: 95px;
		height: 3px;
		background-color: #dfd0b8;
	}
}
.lt_p2 {
	color: #333;
	font-size: 18px;
	line-height: 1.8;
	text-align: left;
	a {
		color: #d43235;
		text-decoration: underline;
	}
}
.lt_p2_hanging {
	padding-left: 1em;
	text-indent: -1em;
}
.slrt_p12 {
	padding-left: 0.43rem;
	position: relative;
	color: #666;
	font-size: 0.4rem;
	font-weight: 700;
	text-align: left;
	&::after {
		content: "";
		top: 50%;
		width: 0.21rem;
		height: 0.33rem;
		margin-top: -0.16rem;
		background-color: #f6dfbc;
		left: 0;
		position: absolute;
	}
}
.slrt_p22 {
	color: #666;
	font-size: 0.37rem;
	margin-top: 0.24rem;
	line-height: 1.8;
	text-align: left;
	a {
		color: #d43235;
		text-decoration: underline;
	}
}
.lt_box {
	max-width: 460px;
	margin: 0 auto;
}
/* 电脑端公共样式结束*/

/* 手机端公共样式开始*/
.nc_p1 {
	text-align: center;
	font-size: 0.51rem;
	color: #c0494b;
	margin-bottom: 0.48rem;
	font-weight: 700;
	animation-duration: 0.7s;
}
.nc_p2 {
	color: #333;
	font-size: 15px;
	line-height: 1.7;
	margin-bottom: 0.67rem;
	text-align: justify;
	animation-duration: 0.7s;
}
/*手机端公共样式结束*/
.ph_act1 {
	background-color: #fff !important;
}
.se_all {
	width: 100%;
	min-height: 900px;
	background-image: url("../../images/bgimg3.png");
	@font-face {
		font-family: "SourceHanSans";
		src: url("../../font/SourceHanSansCN-Regular.otf");
	}
	font-family: "SourceHanSans";
	.tab_act {
		background-color: #efe2d2;
		span {
			color: #d43236 !important;
		}
	}
	.news_pc {
		max-width: 1200px;
		margin: 0 auto;
		padding: 136px 0 85px;
		min-width: 900px;
		.page_tit {
			.nc_p1 {
				text-align: center;
				color: #c0494b;
				font-size: 36px;
				margin-bottom: 46px;
				font-weight: 700;
				animation-duration: 0.7s;
			}
			.nc_p2 {
				text-align: center;
				color: #333;
				font-size: 18px;
				margin-bottom: 80px;
				animation-duration: 0.7s;
			}
		}
		.fwbox1 {
			.nc_d1 {
				background-color: #fff;
				overflow: hidden;
				padding: 15px 56px 15px 15px;
				position: relative;
				margin-bottom: 84px;
				.swiper_wrap {
					position: relative;
					.swiper_box1 {
						.slid_item {
							.sl_left {
								width: 50%;
								img {
									width: 100%;
								}
							}
							.sl_right {
								width: 50%;
								flex: 1;
								padding-left: 86px;
								padding-bottom: 50px;
								.slrt_p1 {
									color: #d43236;
									font-size: 30px;
									padding-bottom: 16px;
									margin-bottom: 24px;
									position: relative;
									text-align: left;
									&::after {
										content: "";
										position: absolute;
										left: 0;
										bottom: 0;
										width: 95px;
										height: 3px;
										background-color: #dfd0b8;
									}
								}
								.slrt_p2 {
									text-align: left;
									color: #333;
									font-size: 18px;
									line-height: 1.8;
								}
							}
						}
					}
					.change_box {
						position: absolute;
						bottom: 15px;
						right: 20px;
						z-index: 19;
						width: 350px;

						img {
							width: 32px;
							cursor: pointer;
						}
						.change_tab {
							flex: 1;
							justify-content: space-around;
                            align-items: flex-end;
                            margin-bottom: 3px;
                            padding: 0 10px;
							span {
								font-size: 14px;
								cursor: pointer;
								color: #555;
                                margin-bottom: 2px;
								white-space: nowrap;
							}
						}
					}
				}
			}
			.tb_box {
				margin-bottom: 44px;
				.tb_item {
					width: 164px;
					height: 62px;
					position: relative;
					cursor: pointer;
					&:nth-child(2),
					&:nth-child(3) {
						margin-left: 80px;
					}
					img {
						position: absolute;
						left: 0;
						width: 164px;
						height: 62px;
					}
					span {
						font-size: 28px;
						color: #555;
                        margin-bottom: 3px;
					}
				}
			}
		}
		.fwbox2 {
			.carton_wrap {
				margin-bottom: 80px;
				.carton_box {
					.carton_item {
						width: 29.5%;
						padding: 15px;
						margin-bottom: 15px;
						background-color: #fff;
						.tm_con {
							background-color: #f3f3f3;
							padding: 22px 15px 16px;
							img {
								height: 240px;
							}
							p {
								text-align: center;
								color: #d43236;
								font-size: 20px;
								padding-top: 18px;
								margin-top: 40px;
								position: relative;
								&::after {
									content: "";
									position: absolute;
									top: 0;
									left: 50%;
									width: 80px;
									height: 3px;
									background-color: #dfd0b8;
									margin-left: -40px;
								}
							}
						}
					}
					&.carton_box_two {
						justify-content: space-between;
						gap: 2%;
						.carton_item {
							width: 49%;
							box-sizing: border-box;
						}
					}
					.ctm2 {
						width: 47%;
						.tm_con {
							padding: 0 15px 16px;
							img {
								height: 331px;
							}
							p {
								font-size: 28px;
								margin-top: 20px;
								&::after {
									content: "";
									position: absolute;
									top: 0;
									left: 50%;
									width: 80px;
									height: 3px;
									background-color: #dfd0b8;
									margin-left: -40px;
								}
							}
						}
					}
				}
			}
		}
		.fwbox4 {
			margin-top: 80px;
			.wh_ul {
				.wh_li {
					width: 46.5%;
					padding: 15px;
					margin-bottom: 30px;
					background-color: #fff;
					.tm_con {
						background-color: #f3f3f3;
						padding: 22px 15px 16px;
						img {
							height: 240px;
						}
						p {
							text-align: center;
							color: #d43236;
							font-size: 20px;
							padding-top: 18px;
							margin-top: 40px;
							position: relative;
							&::after {
								content: "";
								position: absolute;
								top: 0;
								left: 50%;
								width: 80px;
								height: 3px;
								background-color: #dfd0b8;
								margin-left: -40px;
							}
						}
					}
				}
			}
		}
		.fwbox5 {
			margin-top: 80px;
		}
		.rd_box {
			margin-top: 60px;
		}
	}
	.news_phone {
		padding-top: 1.5rem;
		.tab_nav {
			position: fixed;
			width: 100%;
			z-index: 1000;
			top: 1.23rem;
			box-sizing: border-box;
			padding: 0.27rem 0.32rem;
			background: url("../../images/phone/bg1.png") repeat;
			.nav_box {
				background-color: #ddd;
				padding: 0.13rem;
				border-radius: 0.2rem;
				span {
					display: inline-block;
					color: #333;
					font-size: 0.4rem;
					height: 0.93rem;
					line-height: 0.93rem;
					position: relative;
					width: 50%;
					border-radius: 0.13rem;
				}
			}
		}
			.tab_con1 {
				margin-top: 1.2rem;
				padding: 0.43rem 0.4rem 3rem 0.4rem;
				.phbox1 {
				.nc_d11 {
					overflow: hidden;
					margin-bottom: 0.67rem;
					.swiper_wrap {
						position: relative;
						.swiper_box1 {
							.slid_item {
								background-color: #fff;
								padding: 0.2rem 0.27rem;
								box-sizing: border-box;
								.sl_left {
									img {
										width: 100%;
									}
								}
								.sl_right {
									margin-top: 0.29rem;
									.slrt_p1 {
										padding-left: 0.43rem;
										position: relative;
										color: #666;
										font-size: 0.4rem;
										font-weight: 700;
										text-align: left;
										&::after {
											content: "";
											top: 50%;
											width: 0.21rem;
											height: 0.33rem;
											margin-top: -0.16rem;
											background-color: #f6dfbc;
											left: 0;
											position: absolute;
										}
									}
									.slrt_p2 {
										color: #666;
										font-size: 0.37rem;
										margin-top: 0.24rem;
										line-height: 1.8;
										text-align: left;
									}
								}
							}
							.swiper-pagination-bullet-active {
								background: #d43235 !important;
							}
						}
					}
				}
				.tb_box {
					margin-bottom: 1rem;
					justify-content: space-between;
					.tb_item {
						width: calc((100% - 0.5rem) / 3);
						height: 1.1rem;
						position: relative;
						cursor: pointer;
						&:nth-child(2) {
							margin-left: 0;
						}
						img {
							position: absolute;
							left: 0;
							width: 100%;
							height: 1.1rem;
						}
						span {
							font-size: 0.45rem;
							color: #555;
						}
					}
				}
			}
			.phbox2 {
				.carton_wrap {
					margin-bottom: 1rem;
					.carton_box {
						.carton_item {
							padding: 0.2rem;
							margin-bottom: 0.27rem;
							background-color: #fff;
							.tm_con {
								background-color: #f3f3f3;
								padding: 0.29rem;
								img {
									max-width: 4.36rem;
								}
								p {
									position: relative;
									text-align: center;
									color: #d43236;
									font-size: 0.37rem;
									padding-top: 0.24rem;
									margin-top: 0.53rem;
									&::after {
										content: "";
										position: absolute;
										top: 0;
										left: 50%;
										width: 1.07rem;
										height: 0.04rem;
										background-color: #dfd0b8;
										margin-left: -0.53rem;
									}
								}
							}
						}
						&.carton_box_two {
							margin-bottom: 0.1rem;
							.carton_item {
								margin-bottom: 0.1rem;
								padding: 0.12rem;
								.tm_con {
									padding: 0.12rem;
									img {
										max-height: 3.2rem;
										object-fit: contain;
									}
									p {
										margin-top: 0.18rem;
										padding-top: 0.12rem;
									}
								}
							}
						}
					}
					.carton_box2 {
						&.carton_box2_version_three {
							margin-top: 0.15rem;
							> .carton_item:nth-of-type(2) {
								margin-top: 0.25rem;
							}
						}
						.carton_item {
							padding: 0.2rem;
							margin-bottom: 0.27rem;
							margin-top: 0.2rem;
							background-color: #fff;
							.tm_con {
								background-color: #f3f3f3;
								padding: 0.29rem;
								img {
									width: 100%;
								}
							}
						}
					}
				}
			}
		}
		.tab_con2 {
			padding: 1.43rem 0.48rem;
			.pb_p1 {
				color: #c0494b;
				font-size: 19px;
				text-align: center;
				margin-bottom: 0.25rem;
				font-weight: 700;
			}
			.pb_p2 {
				text-align: center;
				font-size: 17px;
				color: #333;
				margin-bottom: 0.533rem;
				font-weight: 700;
			}
			.pb_p3 {
				.p3_item {
					margin-bottom: 0.933rem;
					.p3_item_img {
						position: relative;
						img {
							width: 4rem;
							height: 4rem;
							border-radius: 50%;
							box-shadow: 0 0 8px 0 hsla(0, 0%, 80%, 0.5);
							margin: 0 auto;
						}
						span {
							position: absolute;
							width: 100%;
							text-align: center;
							top: 0.36rem;
							color: #e0e0e0;
							left: 0;
							font-size: 18px;
						}
					}

					.p3_item_p1 {
						margin-top: 0.33rem;
						text-align: center;
						color: #333;
						font-size: 17px;
						margin-bottom: 0.2rem;
					}
					.p3_item_p2 {
						color: #333;
						font-size: 15px;
						line-height: 1.7;
						text-align: left;
					}
				}
			}
			.pb_p4 {
				padding-bottom: 0.3rem;
				.pb_p4_item {
					padding: 0.69rem 0.53rem 0.53rem;
					background-color: #fff;
					margin-bottom: 0.53rem;
					.p4_img {
						text-align: center;
						margin-bottom: 0.25rem;
						img {
							max-width: 70%;
						}
					}
					.p4_text {
						.p4_t1 {
							margin-bottom: 0.13rem;
							color: #c33;
							font-size: 15px;
							text-align: center;
						}
						.p4_t2 {
							margin-bottom: 0.24rem;
							text-align: center;
							color: #d64545;
							font-size: 15px;
							font-weight: 700;
						}
						.p4_t3 {
							color: #333;
							font-size: 12px;
							line-height: 1.8;
							text-align: left;
						}
					}
				}
			}
			.pb_p5 {
				margin-bottom: 0.72rem;
				.pb_p5_item {
					padding: 0.53rem 0.59rem;
					background-color: #f5f5f5;
					.p5_img1 {
						img {
							width: 100%;
						}
					}
					.p5_text {
						color: #333;
						font-size: 15px;
						line-height: 1.8;
						margin-top: 0.16rem;
						text-align: left;
					}
				}
				.pbtm2 {
					background-color: #fff !important;
				}
			}
			.pb_p6 {
				margin-bottom: 1.8rem;
				.p6_item {
					margin-bottom: 0.53rem;
					background-color: #fff;
					padding: 0.47rem 0.47rem 0.37rem 0.4rem;
					border-left: 5px solid #dfd0b7;
					.p6_tit1 {
						color: #1c1c1c;
						font-size: 15px;
						font-weight: 700;
						margin-bottom: 0.29rem;
						text-align: left;
					}
					.p6_text {
						p {
							font-size: 13px;
							line-height: 1.8;
							color: #1c1c1c;
							text-align: left;
						}
					}
				}
			}
		}
	}
}
</style>
